import { render, staticRenderFns } from "./EegFilteredChart.vue?vue&type=template&id=1fcb3f38&"
import script from "./EegFilteredChart.vue?vue&type=script&lang=js&"
export * from "./EegFilteredChart.vue?vue&type=script&lang=js&"
import style0 from "./EegFilteredChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports